module.exports = __webpack_public_path__ + "static/media/sprite.9a0e91fa.svg";